export default __webpack_public_path__ + "static/media/cntr-tracking-rq-12-amber.58e94ee9.svg";